import { useApiService, useRouter, useTl } from "..";
import {
  AppealApi,
  MailTemplateApi,
  ReferentialApi,
  TranslationApi,
  UserApi,
  MailTemplateTypeApi,
  AuthenticateApi,
} from "../../api";
import {
  useAuth,
  useBreadcrumbs,
  useDialog,
  useEventsContext,
  useGlobalData,
  useNavigationContext,
} from "../../contexts";

export function useCommonHooks() {
  return {
    ...useTl(),
    router: {
      ...useRouter(),
    },
    ...useBreadcrumbs(),
    ...useAuth(),
    ...useGlobalData(),
    ...useEventsContext(),
    ...useNavigationContext(),
    ...useDialog(),
    apis: {
      translation: useApiService(TranslationApi),
      user: useApiService(UserApi),
      referential: useApiService(ReferentialApi),
      mailTemplate: useApiService(MailTemplateApi),
      mailTemplateType: useApiService(MailTemplateTypeApi),
      appeal: useApiService(AppealApi),
      authentication: useApiService(AuthenticateApi),
    },
  };
}
